async function t(t){return fetch(t).then(t=>t.blob())}export{t as default};
